

















































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {DialogRemove} from '@/helpers/dialog/DialogRemove'
import {StatusSms} from '@/model/resource/StatusSms'
import {StatusSmsCollection} from '@/model/collection/StatusSmsCollection'
import {ListStatusSmsSchema} from '@/schema/resource/StatusSms/ListStatusSmsSchema'
import {CsvStatusSmsSchema} from '@/schema/resource/StatusSms/CsvStatusSmsSchema'

@Component
export default class ListStatusSmsView extends Mixins(MixinQueryRouter) {
  schema = new ListStatusSmsSchema()
  collection = new StatusSmsCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: StatusSms) {
    Helper.pushByName('editStatusSms', item.$id)
  }

  async removeItem(item: StatusSms) {
    await new DialogRemove(item).confirm(() => item.removeStatusSms())
    await this.collection.listStatusSms()
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new StatusSmsCollection().clearFilters().addFilter(params)

    await csv.listCsvStatusSms()
    new CsvStatusSmsSchema().downloadCsv(csv.all())
  }
}
